


















































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ApsStatic extends Vue {

  headers() {
    return [
      {
        text: 'NSC Levels',
        value: 'NSCLevels',
      },
      {
        text: 'NSC%',
        value: 'NSCperc',
      },
      {
        text: 'APS Levels',
        value: 'APSLevels',
      },
      {
        text: 'APS%',
        value: 'APSperc',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
        align: 'end',
      },
    ];
  }

  data() {
    return {
      apsLevels: [
        {
          NSCLevels: '',
          NSCperc: '',
          APSLevels: '8',
          APSperc: '90 - 100 %',
        },
        {
          NSCLevels: '7',
          NSCperc: '80 - 100 %',
          APSLevels: '7',
          APSperc: '80 - 90 %',
        },
        {
          NSCLevels: '6',
          NSCperc: '70 - 79 %',
          APSLevels: '6',
          APSperc: '70 - 79 %',
        },
        {
          NSCLevels: '5',
          NSCperc: '60 - 69 %',
          APSLevels: '5',
          APSperc: '60 - 69 %',
        },
        {
          NSCLevels: '4',
          NSCperc: '50 - 59 %',
          APSLevels: '4',
          APSperc: '50 - 59 %',
        },
        {
          NSCLevels: '3',
          NSCperc: '40 - 49 %',
          APSLevels: '3',
          APSperc: '40 - 49 %',
        },
        {
          NSCLevels: '2',
          NSCperc: '30 - 39 %',
          APSLevels: '2',
          APSperc: '30 - 39 %',
        },
        {
          NSCLevels: '1',
          NSCperc: '0 - 29 %',
          APSLevels: '0',
          APSperc: '0 - 29 %',
        },
      ],
    };
  }
  
}
